var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerFreewayMaintenanceOfficeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#333333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-529.92v-41.46q88.23-23.24 178.5-32.08 90.27-8.85 181.5-8.85t181.5 8.85q90.27 8.84 178.5 32.08v41.46q-20-5-40-9l-40-8v124.61h-40V-554q-60-9.54-120-13.92-60-4.39-120-4.39t-120 3.89q-60 3.88-120 13.42v132.69h-40v-125.61q-20 4-40 8.5t-40 9.5ZM284.62-160l51.07-313.31q14.93-2 20.23-1.96 5.31.04 20.23-.96L324.62-160h-40Zm103.84-640h40l-14.61 91.31q-15.7 1-20.5 1.34-4.81.35-20.5 2.35l15.61-95ZM460-160h40v-114.62h-40V-160Zm0-225.38h40v-91.31h-40v91.31ZM531.54-800h40l15.61 95q-14.92-1-20.11-1.85-5.19-.84-20.12-1.84L531.54-800Zm103.84 640-51.53-316.23q14.92 1.77 20.61 1.46 5.69-.31 20.62 1.69L675.38-160h-40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFreewayMaintenanceOfficeIcon);
export default __webpack_public_path__ + "static/media/marker-freeway-maintenance-office-icon.ad3583a0d63bb25e3534b816a6e77a03.svg";
export { ForwardRef as ReactComponent };